import CustomerAccountForm from "../../../components/AccountComponents/CustomerAccountForm";

function NewCustomerAccountPage(){
    return(<CustomerAccountForm method="post"  title="Customer"/>)
}


export default NewCustomerAccountPage;